import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/pro-light-svg-icons';
import { Button } from '@shared/components/ui/button';
import Tooltip from '@shared/components/ui/tooltip/tooltip';
import { useTranslation } from 'react-i18next';
import {
  AmazonFbmShipmentExportModal,
  type AmazonFbmShipmentExportModalRef,
} from '../modals/AmazonFbmShipmentExportModal';

interface AmazonFbmShipmentExportButtonProps {
  shopId: number;
  onExportSuccess?: () => void;
}

export const AmazonFbmShipmentExportButton = ({ shopId, onExportSuccess }: AmazonFbmShipmentExportButtonProps) => {
  const { t } = useTranslation('shopsModule');
  const modalRef = useRef<AmazonFbmShipmentExportModalRef>(null);

  return (
    <>
      <Tooltip
        content={t('modals.amazonFbmShipmentExport.tooltip')}
        trigger={
          <Button
            variant="outline"
            size="sm"
            onClick={() => modalRef.current?.open()}
            data-testid="amazon-fbm-shipment-export-button"
          >
            <FontAwesomeIcon icon={faFileExport} className="!w-3.5 !h-3.5 text-icons" />
          </Button>
        }
      />
      <AmazonFbmShipmentExportModal ref={modalRef} shopId={shopId} onSuccess={onExportSuccess} />
    </>
  );
};
